import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

// Types
import { IState } from "@/store";
import { IBrand } from "@/models/brands";
import { ICurrency } from "@/models/constants";

@Component({
  computed: {
    ...mapState({
      brand(state: IState) {
        return state.brand;
      }
    })
  }
})
export default class BrandMixin extends Vue {
  // State
  public brand!: IBrand;

  // Computed props
  public get brandId() {
    return this.brand?.id;
  }

  public get brandCurrencies() {
    return this.$_.orderBy(this.brand.currencies, "name");
  }

  public get brandCurrencyId() {
    return this.brand?.currency_id;
  }

  public get brandCurrency() {
    return this.$_.find(this.brandCurrencies, ["id", this.brandCurrencyId]) as
      | ICurrency
      | undefined;
  }

  public get brandCurrencyCode() {
    return this.brandCurrency?.code || "GBP";
  }

  public get brandCurrencyName() {
    return this.brandCurrency?.name || this.$t("_.brand_currency");
  }

  public get brandPriceListId() {
    return this.brand?.pricelist_id;
  }
}
